module.exports = __webpack_public_path__ + "static/media/remedydouble.6d6dcb91.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/remedydouble.woff2
// module id = 90
// module chunks = 31